import {
  ContactFormActionsContext,
  ContactFormDataContext,
  useContactFormActionsFromContext,
  useContactFormDataFromContext,
} from 'src/SharedCommonContext/ContactFormContext';
import Input from 'src/components/Input';
import Col from 'src/components/Col';
import Row from 'src/components/Row';

const CompanyDetails = () => {
  const { contactFormData }: ContactFormDataContext =
    useContactFormDataFromContext();
  const { setContactFormData }: ContactFormActionsContext =
    useContactFormActionsFromContext();

  if (
    contactFormData.userRole !== 'Service Provider' &&
    contactFormData.userRole !== 'Strata Manager' &&
    contactFormData.userRole !== 'Vendor'
  ) {
    return null;
  }

  return (
    <div style={{ paddingTop: '1rem' }}>
      <Input
        value={contactFormData.companyName}
        onChange={(e: any) =>
          setContactFormData({ companyName: e.target.value })
        }
        label="Company name"
        placeholder="Company name"
        block
        required={contactFormData?.userRole === 'Service Provider'}
      />
    </div>
  );
};

export default CompanyDetails;
